let nextLookAndFeelEnabled: boolean = false;

export const setNextStyleIsEnabled = (isEnabled: boolean) => {
  // Set the flight check boolean
  nextLookAndFeelEnabled = isEnabled;
};

export function isNextStyleEnabled(): boolean {
  // Use next styles if flight is on
  return nextLookAndFeelEnabled;
}
